// Global Inertia config, passed to createInertiaApp as `defaults`.
//
// Inertia 3 serializes arrays in multipart (FormData) requests as indexed keys
// — `mood[0]=grateful` — unless told otherwise. Rails parses those into a hash
// (`{"0" => "grateful"}`), which `permit(mood: [])` silently drops, so every
// array sent with a file upload or `forceFormData` was lost (journal moods,
// photos and photo removals). Bracket keys (`mood[]`) are Rails' native array
// format.
export const INERTIA_DEFAULTS = {
  form: { forceIndicesArrayFormatInFormData: false },
};
